import { useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * Portals its children into the app header's left slot (`#app-header-left`,
 * rendered by PageLayout). Lets a route inject content — e.g. the patient
 * context bar — into the global fixed header without prop-drilling through the
 * layout. Renders nothing until the slot node exists (it does by the time any
 * routed page mounts, since PageLayout is an ancestor).
 */
export const HeaderLeftPortal = ({ children }: { children: ReactNode }) => {
  const [node, setNode] = useState<HTMLElement | null>(null);
  useEffect(() => {
    setNode(document.getElementById('app-header-left'));
  }, []);
  return node ? createPortal(children, node) : null;
};
